import { GovernanceSpecificResultComponent } from '@agilelab/plugin-wb-governance';
import { WbDrawer, WbDrawerContent } from '@agilelab/plugin-wb-platform';
import { FC } from 'react';

interface TestDetailDrawerProps {
  evaluationId: number | string;
  idType?: 'pk' | 'external';
  open: boolean;
  setOpen: () => void;
}

export const TestDetailDrawer: FC<TestDetailDrawerProps> = ({
  open,
  setOpen,
  evaluationId,
  idType,
}) => {
  return (
    <WbDrawer open={open} setOpen={setOpen} title="Test Details">
      <WbDrawerContent>
        {evaluationId && (
          <GovernanceSpecificResultComponent
            evaluationId={evaluationId}
            idType={idType}
          />
        )}
      </WbDrawerContent>
    </WbDrawer>
  );
};
